import React, { Component } from "react";
import { Link } from "react-router-dom";

// Elements
import AboutUsOneSection from "../elements/about-us";

// Images
import bnrImg from "../../images/banner/bnr1.jpg";
import { Helmet } from "react-helmet-async";

class AboutUs extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Om Oss- KBS Center, Ditt Bilvårdsteam i Göteborg</title>
        </Helmet>
        <div className="page-content bg-white">
          <div className="page-banner ovbl-dark" style={{ backgroundImage: "url(" + bnrImg + ")" }}>
            <div className="container">
              <div className="page-banner-entry text-center">
                <h2 className="banner">
                  <span>Om oss</span>
                </h2>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="las la-home"></i>Hem
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Om oss
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <AboutUsOneSection />
        </div>
      </>
    );
  }
}

export default AboutUs;
